export default __webpack_public_path__ + "static/media/bridgeT.40f0c357.svg";